import { getTypedTranslation } from 'syf-js-utilities';
import en from './lang/en';
import es from './lang/es';
var resources = {
    en: en,
    es: es
};
var getTranslation = function () { return getTypedTranslation(resources); };
export default getTranslation;
//# sourceMappingURL=i18n.js.map